import React from "react";
const IconWallet = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M16.071 8.674V5.27H4v10.214h12.071v-3.405"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="bevel"
    />
    <path
      d="M12 12V9h5v3h-5ZM4.928 5.27l9.655-2.787 1.04 3.102"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconWallet;
